export const ACCESS_TOKEN = 'accessTokenBisnis';
export const CONFIRMATION_TOKEN = 'confirmationTokenBisnis';
export const TWOFA_TOKEN = 'twofaTokenBisnis';
export const RESET_TOKEN = 'resetTokenBisnis';
export const SELECT_VERIFICATION_METHOD = 'selectVerificationMethod';

export const languageOption = {
	id: 'Indonesia',
	en: 'English',
};

export * from './endpoint';

export const membership = [
	'Platinum',
	'Digiflazz',
	'Palladium',
	'Exclusive',
	'Exclusive FP',
	'VocaGame',
	'Exclusive VIP',
	'Agen',
	'Super Agen'
];
